/**
 * Resolves the post-authentication navigation target from an untrusted
 * `?redirect=` query parameter. Only same-origin absolute paths are allowed:
 * anything else (external URLs, protocol-relative `//host`, javascript:,
 * empty) falls back to the role-based home. Shared by the sign-in form and
 * the authenticated /login route guard so both redirects agree.
 */
export function resolvePostAuthTarget(raw: string | null | undefined, fallback = "/"): string {
  if (!raw) return fallback;
  if (!raw.startsWith("/")) return fallback;   // relative, absolute URL, javascript: …
  if (raw.startsWith("//")) return fallback;   // protocol-relative external URL
  return raw;
}
